export const HOME = {
  emergentLink: "home-emergent-link",
};

export const LANDING = {
  hero: "landing-hero",
  startRfqBtn: "start-rfq-button",
  navStart: "nav-start-rfq-button",
  navAdmin: "nav-admin-link",
};

export const WIZARD = {
  container: "wizard-container",
  progress: "wizard-progress",
  backBtn: "wizard-back-button",
  nextBtn: "wizard-next-button",
  submitBtn: "wizard-submit-button",
  editBtn: "wizard-edit-button",

  // Sprint 02 free-text request
  requestText: "rfq-request-text",
  analyzeBtn: "rfq-analyze-button",
  analysisLoader: "rfq-analysis-loader",
  addProductBtn: "wizard-add-product-button",
  productBlock: "wizard-product-block",
  removeProductBtn: "wizard-remove-product-button",

  // Legacy aliases
  productInput: "rfq-request-text",

  // Step 2 (legacy wizard)
  quantitySamples: "wizard-quantity-Samples",
  quantityPallet: "wizard-quantity-1-Pallet",
  quantityContainer: "wizard-quantity-1-Container",
  quantityMultipleContainers: "wizard-quantity-Multiple-Containers",
  quantityNotSure: "wizard-quantity-Not-Sure-Yet",

  // Step 3
  countrySelect: "wizard-country-select",
  countryTrigger: "wizard-country-trigger",
  portInput: "wizard-port-input",

  // Step 4
  uploadPdfBtn: "wizard-upload-pdf-button",
  uploadImageBtn: "wizard-upload-image-button",
  skipSpecBtn: "wizard-skip-spec-button",
  fileInput: "wizard-file-input",
  removeFileBtn: "wizard-remove-file-button",
  specNote: "wizard-spec-note",

  // Review contact
  buyerNameInput: "wizard-buyer-name-input",
  buyerEmailInput: "wizard-buyer-email-input",
  buyerPhoneInput: "wizard-buyer-phone-input",
  buyerCompanyInput: "wizard-buyer-company-input",
};

export const QUESTIONS = {
  container: "smart-question-container",
  card: "smart-question-card",
  option: "smart-question-option",
  nextBtn: "smart-question-next",
  backBtn: "smart-question-back",
  progress: "smart-question-progress",
  textInput: "smart-question-text-input",
  complete: "rfq-completion-summary",
};

export const CONFIRMATION = {
  container: "confirmation-container",
  viewRfqBtn: "confirmation-view-rfq-button",
  workspaceBtn: "confirmation-workspace-button",
};

export const RFQ_DETAIL = {
  container: "rfq-detail-container",
  number: "rfq-detail-number",
  timeline: "rfq-detail-timeline",
  status: "rfq-detail-status",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginBtn: "admin-login-submit",
  logoutBtn: "admin-logout-button",
  rfqTable: "admin-rfq-table",
  rfqRow: "admin-rfq-row",
  searchInput: "admin-search-input",
  statusFilter: "admin-status-filter",
  countryFilter: "admin-country-filter",
  intelligenceSection: "admin-intelligence-section",
  completenessScore: "admin-completeness-score",
  originalText: "admin-original-text",
  missingFields: "admin-missing-fields",
  fieldCard: "admin-intelligence-field",
  operationsPage: "admin-operations-page",
  summaryCard: "admin-rfq-summary-card",
  matchesSection: "admin-matches-section",
  supplierCard: "admin-supplier-card",
  supplierToggle: "admin-supplier-toggle",
  supplierSearch: "admin-supplier-search",
  addSupplierBtn: "admin-add-supplier-button",
  sendRfqBtn: "admin-send-rfq-button",
  activityLog: "admin-activity-log",
  offerDesk: "admin-offer-desk",
  offerSupplierList: "admin-offer-supplier-list",
  offerForm: "admin-offer-form",
  offerUnitPrice: "admin-offer-unit-price",
  offerInternalNotes: "admin-offer-internal-notes",
  offerSaveDraft: "admin-offer-save-draft",
  offerPublish: "admin-offer-publish",
  offersNavBtn: "admin-offers-nav-button",
};

export const WORKSPACE = {
  offersPage: "workspace-offers-page",
  comparisonTable: "workspace-comparison-table",
  quotationCard: "workspace-quotation-card",
  viewCatalogBtn: "workspace-view-catalog",
  sortSelect: "workspace-sort-select",
  filterIncoterm: "workspace-filter-incoterm",
  viewOfferBtn: "workspace-view-offer",
  selectOfferBtn: "workspace-select-offer",
  offerDetail: "workspace-offer-detail",
  clarifyInput: "workspace-clarify-input",
  poList: "workspace-po-list",
  poRow: "workspace-po-row",
  poDetail: "workspace-po-detail",
  poApproveBtn: "workspace-po-approve",
  poTimeline: "workspace-po-timeline",
  poOpsPanel: "workspace-po-ops-panel",
  inspectionList: "workspace-inspection-list",
  inspectionRow: "workspace-inspection-row",
  inspectionDetail: "workspace-inspection-detail",
  inspectionTimeline: "workspace-inspection-timeline",
  inspectionChecklist: "workspace-inspection-checklist",
  inspectionAttachments: "workspace-inspection-attachments",
  inspectionOpsPanel: "workspace-inspection-ops-panel",
  freightiqList: "workspace-freightiq-list",
  freightiqRow: "workspace-freightiq-row",
  freightiqDetail: "workspace-freightiq-detail",
  freightiqTimeline: "workspace-freightiq-timeline",
  freightiqMilestones: "workspace-freightiq-milestones",
  freightiqOpsPanel: "workspace-freightiq-ops-panel",
  shipmentList: "workspace-shipment-list",
  shipmentRow: "workspace-shipment-row",
  shipmentDetail: "workspace-shipment-detail",
  shipmentProgress: "workspace-shipment-progress",
  shipmentEvents: "workspace-shipment-events",
  shipmentTimeline: "workspace-shipment-timeline",
  shipmentOpsPanel: "workspace-shipment-ops-panel",
  documentsList: "workspace-documents-list",
  documentsRow: "workspace-documents-row",
  documentsDetail: "workspace-documents-detail",
  documentsFilters: "workspace-documents-filters",
  documentsPreview: "workspace-documents-preview",
  documentsVersions: "workspace-documents-versions",
  documentsTimeline: "workspace-documents-timeline",
  documentsOpsPanel: "workspace-documents-ops-panel",
  dashboard: "workspace-dashboard",
  dashboardSearch: "workspace-dashboard-search",
  dashboardSummary: "workspace-dashboard-summary",
  dashboardOperations: "workspace-dashboard-operations",
  dashboardTasks: "workspace-dashboard-tasks",
  dashboardActivities: "workspace-dashboard-activities",
  dashboardAlerts: "workspace-dashboard-alerts",
  dashboardShipments: "workspace-dashboard-shipments",
  dashboardPOs: "workspace-dashboard-pos",
  dashboardDocuments: "workspace-dashboard-documents",
  dashboardQuickActions: "workspace-dashboard-quick-actions",
  dashboardNotifications: "workspace-dashboard-notifications",
  dashboardNotifBtn: "workspace-dashboard-notif-btn",
  dashboardWidgets: "workspace-dashboard-widgets",
  login: "workspace-login-page",
  registerName: "workspace-register-name",
  registerCompany: "workspace-register-company",
  registerPhone: "workspace-register-phone",
  registerEmail: "workspace-register-email",
  registerSubmit: "workspace-register-submit",
};
